import type { ButtonHTMLAttributes } from "react";

export default function PrimaryButton({
    className = "",
    disabled,
    children,
    ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            {...props}
            disabled={disabled}
            className={
                "inline-flex min-h-touch items-center justify-center gap-2 rounded-lg bg-brand-600 px-5 py-2.5 " +
                "text-sm font-semibold text-white shadow-sm transition hover:bg-brand-700 " +
                "focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 " +
                "disabled:cursor-not-allowed disabled:opacity-50 " +
                className
            }
        >
            {children}
        </button>
    );
}
